import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subject, combineLatest, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { switchMap } from 'rxjs/operators';

import { AngularFireDatabase, AngularFireList } from '@angular/fire/compat/database';

@Injectable({
  providedIn: 'root'
})
export class RealtimedbService {

  constructor(private db: AngularFireDatabase) {

  }

  singlePathUpdate(path: string, key: string, data: {}){
    this.db.list(path).set(key, data); //update

    //set(ref(this.db, path), {key, data})
  }

  /*singlePathRemove(path: string, key: string){
    console.log("here")
    this.db.list(path).remove(key);
  }*/

  singlePathRemove(path: string){
    //console.log("here")
    return this.db.list(path).remove();
    //return remove(ref(this.db, path))
  }
  
  multiPathUpdate(updateData){
    this.db.database.ref().update(updateData)

    //set(ref(this.db), updateData)
  }

  // rmsTrigger(senTarget){
  //   let reference = ref(this.db, '/sensor_settings/' + senTarget)
  //   // let triggerVal = this.db.list('/sensor_settings/' + senTarget).snapshotChanges().pipe(
  //   //   map(docArray => {
  //   //     return docArray.map(doc => {
  //   //       const data = doc.payload.val() as {};
  //   //       const id = doc.payload.key;
  //   //       //console.log(id)
  //   //       //console.log(data)

  //   //       return { id, data };
  //   //     })
  //   //   }));
  //   //console.log(triggerVal);
    
  //   let triggerVal = onValue(reference, (snapshot) => {
      
  //   })
  //   return triggerVal;
  // }

  getOnChange(path){
    return this.db.list(path).snapshotChanges()
    // return onValue(ref(this.db, path), (snapshot) => {
      
    // })
  }

  // sensorsNames(){
  //   return this.db.list('/sensor_names').snapshotChanges()
  // }

  getOnce(path){
    this.db.database.ref(path)
    .once('value')
    .then(snapshot => {
      console.log(snapshot.key)
      const records = snapshot.val();
      console.log(records);
    })
    .catch(error => console.log(error));
  }

  getOnce1(path){
    return this.db.database.ref(path).once('value')
  }
  
  getFirst(path){
    return this.db.database.ref(path).limitToFirst(1).once('value')
  }

  getLast(path) {
    return this.db.database.ref(path).limitToLast(1).once('value')
  }

  getNext(path, event){
    return this.db.database.ref(path).orderByKey().startAfter(event).limitToFirst(2501).once('value')
  }
  
  getListAfter(path, event){
    return this.db.database.ref(path).orderByKey().startAt(event).limitToFirst(250).once('value')
  }

  getListBefore(path, event){
    return this.db.database.ref(path).orderByKey().endAt(event).limitToLast(250).once('value')
  }

  getLiveLastHour(path) {
    return this.db.database.ref(path).orderByKey().limitToLast(2250).once('value')
  }

  getOn(path){
    let moduleData = []

    this.db.database.ref(path)
    .on('value', function(snapshot){
      snapshot.forEach(function(data){
        moduleData = data.val()
      })
    })

    return moduleData
  }

}